<template>
    <Tabs sticky v-model="activeName">
        <Tab title="全部" name="all">
        </Tab>
        <Tab title="待付款" name="UN_PAID">
        </Tab>
        <Tab title="已付款" name="PAID">
        </Tab>
        <All :key="activeName" :state="activeName"/>
    </Tabs>
</template>

<script>
    import {Tab, Tabs} from "vant";
    import All from "./tab/All"

    export default {
        components: {Tab, Tabs, All},
        data() {
            return {
                activeName: 'all'
            }
        },
        mounted() {
        }
    }
</script>

<style scoped>

</style>